import {
  CLEAR_INDIVIDUAL_SAHAKARI,
  CLEAR_SAHAKARI_MAIN_BRANCH,
  GET_INDIVIDUAL_SAHAKARI,
  GET_SAHAKARI_MAIN_BRANCH,
  GET_SAHAKARI_SUCCESS,
  GET_SAHAKARI_STATS,
} from "../actions/sahakari";

const initialState = {
  sahakariData: [],
  individualSahakari: {},
  sahakariMainBranch: [],
  sahakariStats: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_SAHAKARI_SUCCESS:
      return { ...state, sahakariData: action.payload };

    case GET_INDIVIDUAL_SAHAKARI:
      return { ...state, individualSahakari: action.payload };

    case CLEAR_INDIVIDUAL_SAHAKARI:
      return { ...state, individualSahakari: {} };

    case GET_SAHAKARI_MAIN_BRANCH:
      return { ...state, sahakariMainBranch: action.payload };

    case CLEAR_SAHAKARI_MAIN_BRANCH:
      return { ...state, sahakariMainBranch: [] };

    case GET_SAHAKARI_STATS:
      return { ...state, sahakariStats: action.payload };

    default:
      return state;
  }
};
